export const ROOT_PATH = '/';

// Top Level paths for each Flow
export const FLOW_PATHS = {
  applyStrLicense: '/apply-str-license',
}

export const dummyFormData = {
  postPayload: {
    businessLicense: "12345",
    hostEmail: "email@email.com",
    hostMailingAddress: "1320 PALOMA AVE, BURLINGAME, CA, 94010",
    hostName: "John Doe",
    hostPhone: "5555555555",
    numVehicles: 0,
    parcelNumber: "026084190",
    rentedByOwner: true,
  },
  licenseFeeInfo: {
    "paymentId": 4,
    "paymentDate": "2021/06/07",
    "licence_no": null,
    "application_no": "A00021",
    "display_id": "A00021",
    "details": [
        {
            "period": "Jul 2020 - Jun 2021",
            "taxableReceipts": 0,
            "totDue": 0,
            "licenseFee": 50,
            "assessment": 0,
            "latePenalties": 0,
            "accruedInterest": 0,
            "type": "application_fee",
            "total": 50
        }
    ],
    "summary": {
        "taxableReceipts": 0,
        "totDue": 0,
        "assessment": 0,
        "latePenalties": 0,
        "accruedInterest": 0,
        "licenseFee": 50,
        "total": 50
    },
    "ccFee": 1.8,
    "achFee": 0.4,
    "ccTotal": 51.8,
    "achTotal": 50.4
  },
  newLicenseInfo: {
    "applicationNumber": "A1234",
    "businessLicense": "90-90",
    "rentedByOwner": true,
    "ownerName": "Margaret Wilson",
    "ownerPhone": "239-123-1233",
    "ownerMailingAddress": "0416 Clement Centers, Burlingame 92101",
    "ownerEmail": "not_used_hopefully@gmail.com",
    "localContactName": "Joe the local contact",
    "localContactPhone": "555-123-4567",
    "localContactEmail": "joe@myspace.com",
    "localContactMailingAddress": "0616 Clement Centers, Burlingame 92101",
    "numVehicles": 4,
    "signatory": "Joe",
    "parcelNumber": "069460025000"
  },
};
